import React from 'react';
import { Link } from 'react-router-dom';
import scrollToElement from 'scroll-to-element';
import prd from "../../Core/Products";
import Slider from 'react-slick';
import {Modal} from 'react-bootstrap';
import call from "../../Core/Services";
import WhatsAppButton from '../../Common/WhatsAppButton';

import DocumentMeta from 'react-document-meta';

const getSpecIcon = (name) => {
	const n = (name || '').toLowerCase();
	if (n.includes('gear')) return 'pe-7s-config';
	if (n.includes('brems')) return 'pe-7s-shield';
	if (n.includes('hjul') || n.includes('fælg') || n.includes('dæk')) return 'pe-7s-compass';
	if (n.includes('lever') || n.includes('samlet')) return 'pe-7s-car';
	if (n.includes('farv') || n.includes('color')) return 'pe-7s-paint';
	if (n.includes('vægt') || n.includes('vaegt')) return 'pe-7s-gleam';
	if (n.includes('stel') || n.includes('størrelse') || n.includes('str')) return 'pe-7s-diamond';
	if (n.includes('sadel') || n.includes('styr') || n.includes('krank') || n.includes('pedal')) return 'pe-7s-tools';
	if (n.includes('lås') || n.includes('forsikr')) return 'pe-7s-lock';
	return 'pe-7s-check';
};

const getFeatureBadges = (desc) => {
	if (!desc) return [];
	const text = desc.toLowerCase();
	const badges = [];

	if (text.includes('10 års') || text.includes('stelgaranti')) {
		badges.push({ icon: 'pe-7s-shield', label: '10 års stelgaranti' });
	}
	if (text.includes('100 % samlet') || text.includes('100% samlet') || text.includes('leveres:100 %')) {
		badges.push({ icon: 'pe-7s-car', label: '100% samlet & køreklar' });
	}
	if (text.includes('forsikring') || text.includes('lås')) {
		badges.push({ icon: 'pe-7s-lock', label: 'Godkendt lås' });
	}
	if (text.includes('rustfri')) {
		badges.push({ icon: 'pe-7s-check', label: 'Rustfrie komponenter' });
	}
	if (text.includes('shimano')) {
		badges.push({ icon: 'pe-7s-config', label: 'Shimano gear' });
	}
	return badges;
};

class ProductDescription extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.data = {
			productType: this.props.match.path.includes('cycle') ? 'CYCLE' : 'ACCESSORY',
			productURI: this.props.match.params.page_uri
		};

		this.state = {
			product : null,
			showModal: false,
			message : '',
			showLightbox: false,
			lightboxIndex: 0,
		}		
	}

	getProduct = () => {

		prd.getProduct(this.data, (response) => {
			this.setState({
				product: response.data,
				lightboxIndex: 0,
				showLightbox: false,
			});
		});

	}

	componentWillMount() {
		this.getProduct();	
	}

	componentDidMount() {
		window.addEventListener('keydown', this.handleKeyDown);
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.handleKeyDown);
		document.body.style.overflow = '';
	}

	getAllImages = () => {
		if (!this.state.product || !this.state.product.meta) return [];
		const list = [
			{
				sliderUrl: `${this.state.product.meta.cloudinary_path}w_800/q_auto/${this.state.product.meta.thumb_image_id}`,
				fullUrl: `${this.state.product.meta.cloudinary_path}w_1400/q_auto/${this.state.product.meta.thumb_image_id}`,
				thumbUrl: `${this.state.product.meta.cloudinary_path}c_fill,w_160,h_110,q_auto/${this.state.product.meta.thumb_image_id}`,
				alt: this.state.product.meta.title,
			},
		];

		if (Array.isArray(this.state.product.images)) {
			for (let i = 0; i < this.state.product.images.length; i++) {
				const img = this.state.product.images[i];
				list.push({
					sliderUrl: `${img.cloudinary_path}w_800/q_auto/${img.image_id}`,
					fullUrl: `${img.cloudinary_path}w_1400/q_auto/${img.image_id}`,
					thumbUrl: `${img.cloudinary_path}c_fill,w_160,h_110,q_auto/${img.image_id}`,
					alt: `${this.state.product.meta.title} ${i + 2}`,
				});
			}
		}

		return list;
	}

	openLightbox = (index = 0) => {
		document.body.style.overflow = 'hidden';
		this.setState({
			showLightbox: true,
			lightboxIndex: index,
		});
	}

	closeLightbox = () => {
		document.body.style.overflow = '';
		this.setState({
			showLightbox: false,
		});
	}

	prevLightboxImage = (e) => {
		if (e) e.stopPropagation();
		const allImages = this.getAllImages();
		if (!allImages.length) return;
		this.setState((prevState) => ({
			lightboxIndex: (prevState.lightboxIndex - 1 + allImages.length) % allImages.length,
		}));
	}

	nextLightboxImage = (e) => {
		if (e) e.stopPropagation();
		const allImages = this.getAllImages();
		if (!allImages.length) return;
		this.setState((prevState) => ({
			lightboxIndex: (prevState.lightboxIndex + 1) % allImages.length,
		}));
	}

	handleKeyDown = (e) => {
		if (!this.state.showLightbox) return;
		if (e.key === 'Escape') {
			this.closeLightbox();
		} else if (e.key === 'ArrowRight') {
			this.nextLightboxImage();
		} else if (e.key === 'ArrowLeft') {
			this.prevLightboxImage();
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.match.params.page_uri !== this.props.match.params.page_uri || nextProps.match.path !== this.props.match.path) {
			this.data = {
				productType: nextProps.match.path.includes('cycle') ? 'CYCLE' : 'ACCESSORY',
				productURI: nextProps.match.params.page_uri
			};
			document.body.style.overflow = '';
			this.setState({ product: null, showLightbox: false, lightboxIndex: 0 }, () => this.getProduct());
		}
	}

	close = () => {
		this.setState({ showModal: false });
	}

	open = () => {
		this.setState({ showModal: true });
	}


	submitForm = ( e ) => {
        
        e.preventDefault();

        let formData = {
            'name'      : this.refs.name.value,
            'email'     : this.refs.email.value,
            'phone'     : this.refs.phone.value,
            'comment'   : this.refs.comment.value,
            'category'  : this.data.productType,

            'metaData'  : {
            	'title'   	: this.state.product.meta.title,
            	'url'  	  	: window.location.href,
            	'prod_id' 	: this.data.productType === 'CYCLE' ? this.state.product.meta.cyc_id : this.state.product.meta.acc_id 
            },
        };

        call.submitForm( formData, () => {
            
            this.refs.name.value    	= '';
            this.refs.email.value       = '';
            this.refs.phone.value       = '';
            this.refs.comment.value     = '';
    
            this.setState({
                message: 'Tak for din forespørgsel, vi svarer som regel i løbet af få timer'
            });

            setTimeout( () => {                
                this.setState({
                    message: ''
                });
            }, 10000)

        });


    }

	render() {
			
		if( this.state.product == null ) {
			return (
				<div className="product-description-page is-loading">
					<div className="container">
						{/* Breadcrumb Skeleton */}
						<div className="product-breadcrumb">
							<div className="skeleton-pill skeleton-shimmer" style={{ width: '160px', height: '34px' }} />
						</div>

						{/* Hero Row Skeleton (Left Image Slider + Right Details Card) */}
						<div className="row product-hero-row">
							<div className="col-md-7 col-sm-12 col-xs-12">
								<div className="slick-product-slider skeleton-slider-card">
									<div className="skeleton-image-fill skeleton-shimmer" />
									<div className="skeleton-slider-dots">
										<span /><span /><span />
									</div>
								</div>
							</div>

							<div className="col-md-5 col-sm-12 col-xs-12">
								<div className="title-wrapper skeleton-title-card">
									<div className="skeleton-line skeleton-shimmer" style={{ width: '35%', height: '12px', marginBottom: '12px' }} />
									<div className="skeleton-line skeleton-shimmer" style={{ width: '85%', height: '28px', marginBottom: '10px' }} />
									<div className="skeleton-line skeleton-shimmer" style={{ width: '60%', height: '28px', marginBottom: '24px' }} />

									<div className="price-card skeleton-price-card">
										<div className="skeleton-line skeleton-shimmer" style={{ width: '50px', height: '10px', marginBottom: '10px' }} />
										<div className="skeleton-price-row">
											<div className="skeleton-line skeleton-shimmer" style={{ width: '140px', height: '30px' }} />
											<div className="skeleton-line skeleton-shimmer" style={{ width: '85px', height: '18px' }} />
											<div className="skeleton-pill skeleton-shimmer" style={{ width: '90px', height: '24px' }} />
										</div>
									</div>

									<div className="build-for">
										<div className="skeleton-line skeleton-shimmer" style={{ width: '75px', height: '10px', marginBottom: '10px' }} />
										<div className="skeleton-pills-group">
											<div className="skeleton-box skeleton-shimmer" style={{ width: '96px', height: '26px' }} />
											<div className="skeleton-box skeleton-shimmer" style={{ width: '96px', height: '26px' }} />
										</div>
									</div>

									{this.data.productType === 'CYCLE' && (
										<div className="product-highlights skeleton-highlights">
											<div className="skeleton-highlight-row">
												<span className="skeleton-circle skeleton-shimmer" />
												<div className="skeleton-line skeleton-shimmer" style={{ width: '78%', height: '14px' }} />
											</div>
											<div className="skeleton-highlight-row">
												<span className="skeleton-circle skeleton-shimmer" />
												<div className="skeleton-line skeleton-shimmer" style={{ width: '68%', height: '14px' }} />
											</div>
											<div className="skeleton-highlight-row">
												<span className="skeleton-circle skeleton-shimmer" />
												<div className="skeleton-line skeleton-shimmer" style={{ width: '74%', height: '14px' }} />
											</div>
										</div>
									)}

									<div className="product-cta-group">
										<div className="btn skeleton-btn skeleton-shimmer" />
										<div className="btn skeleton-btn skeleton-shimmer" />
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Lower Sections Skeleton: Description, Specifications & Guarantees */}
					<div className="container" id="product-details">
						<div className="row">
							<div className="col-sm-12">
								{/* Description Card Skeleton */}
								<div className="details-block">
									<div className="skeleton-line skeleton-shimmer" style={{ width: '130px', height: '24px', borderRadius: '20px', marginBottom: '8px' }} />
									<div className="skeleton-line skeleton-shimmer" style={{ width: '220px', height: '26px', marginBottom: '16px' }} />
									<div className="description-card">
										<div className="skeleton-line skeleton-shimmer" style={{ width: '92%', height: '14px', marginBottom: '12px' }} />
										<div className="skeleton-line skeleton-shimmer" style={{ width: '86%', height: '14px', marginBottom: '12px' }} />
										<div className="skeleton-line skeleton-shimmer" style={{ width: '64%', height: '14px' }} />
									</div>
								</div>

								{/* Specifications Grid Skeleton */}
								<div className="details-block">
									<div className="skeleton-line skeleton-shimmer" style={{ width: '130px', height: '24px', borderRadius: '20px', marginBottom: '8px' }} />
									<div className="skeleton-line skeleton-shimmer" style={{ width: '190px', height: '26px', marginBottom: '16px' }} />
									<div className="spec-grid-container">
										{[1, 2, 3, 4, 5, 6].map((item) => (
											<div key={item} className="spec-card skeleton-spec-card">
												<div className="spec-icon-box skeleton-shimmer" />
												<div className="spec-text-wrap" style={{ flex: 1 }}>
													<div className="skeleton-line skeleton-shimmer" style={{ width: '45%', height: '11px', marginBottom: '8px' }} />
													<div className="skeleton-line skeleton-shimmer" style={{ width: '70%', height: '14px' }} />
												</div>
											</div>
										))}
									</div>
								</div>
							</div>

							{/* Guarantee Cards Skeleton */}
							{this.data.productType === 'CYCLE' && (
								<div className="col-sm-12">
									<div className="guarantees-trust-bar margin-bottom-80">
										<div className="row">
											{[1, 2, 3].map((card) => (
												<div className="col-sm-4 trust-col" key={card}>
													<div className="trust-item">
														<div className="trust-icon skeleton-shimmer" />
														<div className="trust-content" style={{ flex: 1 }}>
															<div className="skeleton-line skeleton-shimmer" style={{ width: '60%', height: '16px', marginBottom: '8px' }} />
															<div className="skeleton-line skeleton-shimmer" style={{ width: '90%', height: '13px', marginBottom: '6px' }} />
															<div className="skeleton-line skeleton-shimmer" style={{ width: '70%', height: '13px' }} />
														</div>
													</div>
												</div>
											))}
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			);
		} else {

			let categories 	= [];
			let buildFor 	= [];

			if( this.data.productType === 'CYCLE' ){
				
				for(let i = 0; i < this.state.product.categories.length; i++){
					categories.push( this.state.product.categories[i].category_name )
				}
				categories = categories.join(', ');	
				
				if( this.state.product.meta.build_for.indexOf('M') > -1 ) {
					buildFor.push(<li key="M">Herrecykler</li>)	
				}
				if( this.state.product.meta.build_for.indexOf('F') > -1 ) {
					buildFor.push(<li key="F">Damecykler</li>)	
				}
				if( this.state.product.meta.build_for.indexOf('K') > -1 ) {
					buildFor.push(<li key="K">Børnecykler</li>)	
				}
				if( this.state.product.meta.build_for.indexOf('E') > -1 ) {
					buildFor.push(<li key="E">El - Cykler</li>)	
				}
				if( this.state.product.meta.build_for.indexOf('A') > -1 ) {
					buildFor.push(<li key="A">Alle</li>)	
				}

			}

			let specifications = [];
			for(let i = 0; i < this.state.product.specifications.length; i++){
				const spec = this.state.product.specifications[i];
				if (spec && (spec.spec_name || spec.spec_value)) {
					specifications.push(
						<div className="spec-card" key={i}>
							<div className="spec-icon-box">
								<span className={getSpecIcon(spec.spec_name)} />
							</div>
							<div className="spec-text-wrap">
								<span className="spec-name">{spec.spec_name}</span>
								<span className="spec-val">{spec.spec_value}</span>
							</div>
						</div>
					);
				}
			}

			const featureBadges = getFeatureBadges(this.state.product.meta.description);

			const hasSpecifications = specifications.length > 0;
			const strikePrice = Number(this.state.product.meta.strike_price) || 0;
			const finalPrice = Number(this.state.product.meta.final_price) || 0;
			const savings = strikePrice > finalPrice ? strikePrice - finalPrice : 0;

			const allImages = this.getAllImages();
			const activeLightboxImg = allImages[this.state.lightboxIndex] || allImages[0];

			let settings = {
				dots: true,
				autoplay: true,
				infinite: true,
				speed: 500,
				autoplaySpeed: 10000,
				slidesToShow: 1,
				slidesToScroll: 1,
				afterChange: (current) => this.setState({ lightboxIndex: current }),
			};
			
			let sliderItem = allImages.map((imgObj, idx) => (
				<div className="image-slider" key={idx}>
					<div className="inner" onClick={() => this.openLightbox(idx)}>
						<img src={imgObj.sliderUrl} alt={imgObj.alt} />					
					</div>
				</div>
			));

			const meta = {
	            title:          this.state.product.meta.title,
	            description:    this.state.product.meta.description,
	            meta: {
	                charset:    'utf-8',
	                name: {
	                    keywords: this.state.product.meta.title
	                }
	            }
	        };
			
			return (

				<div className="product-description-page">
                	
                	<DocumentMeta {...meta} />

	                <div className="container">
	                	<div className="product-breadcrumb">
	                		<Link to={this.data.productType === 'CYCLE' ? '/cycles' : '/accessories'} className="back-link">
	                			<span className="pe-7s-angle-left" /> Tilbage til {this.data.productType === 'CYCLE' ? 'cykler' : 'tilbehør'}
	                		</Link>
	                	</div>
	                	
	                	<div className="row product-hero-row">	                		
	                		<div className="col-md-7 col-sm-12 col-xs-12">
	                			<div className="slick-product-slider">          						
									<Slider {...settings} className="service-slider">									
										{sliderItem}
									</Slider>
									<button
										type="button"
										className="fullscreen-preview-btn"
										onClick={() => this.openLightbox(this.state.lightboxIndex)}
										title="Se alle billeder i fuld skærm"
									>
										<span className="pe-7s-expand1" /> Fuld skærm ({allImages.length})
									</button>
									{
										this.data.productType === 'CYCLE' && (
											<div className="shimano-logo">
												<img src="../images/shimano-logo.png" alt="Shimano" />
											</div>
										)
									}
	                			</div>
	                		</div>
	                		<div className="col-md-5 col-sm-12 col-xs-12">
	                			<div className="title-wrapper">
	                				{categories && (
	                					<span className="product-category-label">{categories}</span>
	                				)}
	                				<h1 className="product-main-title">
	                					{this.state.product.meta.title}
	                				</h1>

	                				<div className="price-card">
	                					<span className="price-label">PRIS</span>
	                					<div className="price-values">
	                						<span className="final-price">DKK {this.state.product.meta.final_price}</span>
	                						{ this.state.product.meta.strike_price ? (
	                							<s className="strike-price">DKK {this.state.product.meta.strike_price}</s>
	                						) : null }
	                						{ savings > 0 && (
	                							<span className="savings-badge">Spar {savings} kr.</span>
	                						)}
	                					</div>
	                				</div>

	                				{buildFor.length > 0 && (
		                				<div className="build-for">
		                					<div className="head">Bygget til</div>
		                					<ul>
		                						{buildFor}	                								
		                					</ul>
		                				</div>
	                				)}

	                				{this.data.productType === 'CYCLE' && (
	                					<ul className="product-highlights">
	                						<li><span className="pe-7s-check" /> 10 års stelgaranti &amp; 1 års gratis eftersyn</li>
	                						<li><span className="pe-7s-check" /> Leveres 100% samlet og køreklar</li>
	                						<li><span className="pe-7s-check" /> Levering i Storkøbenhavn fra 200 DKK</li>
	                					</ul>
	                				)}

	                				<div className="product-cta-group">
									    {hasSpecifications ? (
									    	<button
									    		type="button"
									    		className="btn btn-default btn-long"
									    		onClick={() => scrollToElement('#full-specification', { offset: -95, duration: 450 })}
									    	>
									    		Flere specifikationer
									    	</button>
									    ) : (
									    	<button
									    		type="button"
									    		className="btn btn-default btn-long"
									    		onClick={() => scrollToElement('#product-details', { offset: -95, duration: 450 })}
									    	>
									    		{this.data.productType === 'CYCLE' ? 'Beskrivelse & Garanti' : 'Læs beskrivelse'}
									    	</button>
									    )}
									    <button
									    	type="button"
									    	className="btn btn-primary btn-long"
									    	onClick={this.open}
									    >
									    	Send forespørgsel
									    </button>
									</div>
	                			</div>
	                		</div>
	                	</div>
	                </div>


	                <div className="container" id="product-details">
	                	<div className="row">
	                		<div className="col-sm-12">
	                			{this.state.product.meta.description && (
		                			<div className="details-block description-block">
		                				<div className="details-header">
		                					<div className="details-header-badge">
		                						<span className="pe-7s-note2" />
		                						<span>Beskrivelse</span>
		                					</div>
		                					<h3 className="details-title">Produktbeskrivelse</h3>
		                				</div>
		                				<div className="details-content-card description-card">
		                					{featureBadges.length > 0 && (
		                						<div className="desc-features-row">
		                							{featureBadges.map((badge, idx) => (
		                								<span key={idx} className="desc-feature-chip">
		                									<i className={badge.icon} />
		                									{badge.label}
		                								</span>
		                							))}
		                						</div>
		                					)}
		                					<p className="description-text">{this.state.product.meta.description}</p>
		                				</div>
		                			</div>
	                			)}

	                			{hasSpecifications && (
		                			<div className="details-block spec-block" id="full-specification">
		                				<div className="details-header">
		                					<div className="details-header-badge">
		                						<span className="pe-7s-tools" />
		                						<span>Tekniske data</span>
		                					</div>
		                					<h3 className="details-title">Specifikationer</h3>
		                				</div>
		                				<div className="spec-grid-container">
		                					{specifications}
		                				</div>
		                			</div>
	                			)}
	                		</div>

	                		{
	                			this.data.productType === 'CYCLE' && (
			                		<div className="col-sm-12">
			                			<div className="guarantees-trust-bar margin-bottom-80">
			                				<div className="row">
			                					<div className="col-sm-4 trust-col">
			                						<div className="trust-item">
			                							<div className="trust-icon">
			                								<span className="pe-7s-shield" />
			                							</div>
			                							<div className="trust-content">
			                								<h4>10 års garanti</h4>
			                								<p>Vi tilbyder vores kunder 10 års garanti på stellet og et års gratis eftersyn.</p>
			                							</div>
			                						</div>
			                					</div>

			                					<div className="col-sm-4 trust-col">
			                						<div className="trust-item">
			                							<div className="trust-icon">
			                								<span className="pe-7s-refresh-2" />
			                							</div>
			                							<div className="trust-content">
			                								<h4>Returret og garanti</h4>
			                								<p>Vi tilbyder 14 dages returret (varen skal være ubrugt) samt 2 års reklamationsret.</p>
			                							</div>
			                						</div>
			                					</div>

			                					<div className="col-sm-4 trust-col">
			                						<div className="trust-item">
			                							<div className="trust-icon">
			                								<span className="pe-7s-wallet" />
			                							</div>
			                							<div className="trust-content">
			                								<h4>Betaling</h4>
			                								<p>Betaling kan ske kontant samt med Dankort og MobilePay.</p>
			                							</div>
			                						</div>
			                					</div>
			                				</div>
			                			</div>	                			
			                		</div>
	                			)
	                		}
	                	</div>
	                </div>

					{/* Full-Screen Image Preview Slider Modal */}
					{this.state.showLightbox && activeLightboxImg && (
						<div className="product-lightbox-overlay" onClick={this.closeLightbox}>
							<div className="lightbox-header" onClick={(e) => e.stopPropagation()}>
								<div className="lightbox-title-wrap">
									<h4>{this.state.product.meta.title}</h4>
									<span className="lightbox-counter">
										Billede {this.state.lightboxIndex + 1} af {allImages.length}
									</span>
								</div>
								<button
									type="button"
									className="lightbox-close-btn"
									onClick={this.closeLightbox}
									aria-label="Luk fuldskærmsvisning"
								>
									&times;
								</button>
							</div>

							<div className="lightbox-stage" onClick={(e) => e.stopPropagation()}>
								{allImages.length > 1 && (
									<button
										type="button"
										className="lightbox-nav prev"
										onClick={this.prevLightboxImage}
										aria-label="Forrige billede"
									>
										<span className="pe-7s-angle-left" />
									</button>
								)}

								<div className="lightbox-main-img-wrap">
									<img
										src={activeLightboxImg.fullUrl}
										alt={activeLightboxImg.alt}
									/>
								</div>

								{allImages.length > 1 && (
									<button
										type="button"
										className="lightbox-nav next"
										onClick={this.nextLightboxImage}
										aria-label="Næste billede"
									>
										<span className="pe-7s-angle-right" />
									</button>
								)}
							</div>

							<div className="lightbox-thumbs-bar" onClick={(e) => e.stopPropagation()}>
								<div className="lightbox-thumbs-track">
									{allImages.map((imgObj, idx) => (
										<button
											type="button"
											key={idx}
											className={idx === this.state.lightboxIndex ? 'lightbox-thumb active' : 'lightbox-thumb'}
											onClick={() => this.setState({ lightboxIndex: idx })}
										>
											<img src={imgObj.thumbUrl} alt={imgObj.alt} />
										</button>
									))}
								</div>
							</div>
						</div>
					)}


					<Modal show={this.state.showModal} onHide={this.close}>
						<Modal.Header closeButton>
							<Modal.Title>Forhør nu for flere detaljer</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="row">
								<div className="col-md-12">
									
									<div className={ this.state.message ? 'alert alert-success show' : 'alert alert-success' }>
		                                <a className="close" onClick={ () => this.setState({message: '' }) } >&times;</a>
		                                { this.state.message }
		                            </div>

									<form id="enquire-form" method="post" onSubmit={ this.submitForm } >
										
										<div className="row">
											<div className="form-group col-md-6">
												<label className="sr-only" htmlFor="first-name">Dit navn</label>
												<input type="text" required ref="name" name="first-name" placeholder="Dit navn" minLength={3} maxLength={15} className="form-control" />
												<span className="error" />
											</div>
											<div className="form-group col-md-6">
												
												<label className="sr-only" htmlFor="phone-number">Telefonnummer</label>
												<input type="number" required ref="phone" name="phone-number" placeholder="Telefonnummer" className="form-control" />
												<span className="error" />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-md-12">
												<label className="sr-only" htmlFor="email">Email adresse</label>
												<input type="email" required ref="email" name="email" placeholder="Email adresse" minLength={3} maxLength={50} className="form-control" />
												<span className="error" />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-sm-12">
												<label className="sr-only">Forespørgselsdetaljer</label>
												<textarea required ref="comment" name="enquiry_details" className="form-control" minLength={10} maxLength={300} rows={5} placeholder="Indtast din forespørgsel her..." />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-xs-4">
												<input type="submit" name="Submit" className="btn btn-primary btn-block" defaultValue="Indsend" />
											</div>
										</div>
																		
									</form>

								</div>
							</div>
						</Modal.Body>
					</Modal>

					<WhatsAppButton 
						customMessage={`Hej! Jeg er interesseret i denne ${this.data.productType === 'CYCLE' ? 'cykel' : 'tilbehør'}: ${this.state.product.meta.title}. Kan I give mig flere detaljer?`} 
					/>

				</div>
			);
		}
	}
}

export default ProductDescription;



// WEBPACK FOOTER //
// ./src/Pages/Products/ProductDescription.js